module.exports = __webpack_public_path__ + "img/bg_home@2x.b65fb219.png";